/**
 * Copyright (c) 2023 TechDivision GmbH
 * All rights reserved
 *
 * This product includes proprietary software developed at TechDivision GmbH, Germany
 * For more information see https://www.techdivision.com/
 *
 * To obtain a valid license for using this software please contact us at
 * license@techdivision.com
 *
 * @author Sebastian Hartmann <s.hartmann@techdivision.com>
 */

export const jumpersThemeConfig = {
  palette: {
    primary: {
      main: '#afca33',
      contrastText: '#fff',
    },
    secondary: {
      main: '#afca33',
      contrastText: '#fff',
    },
  },
  components: {
    MuiPopover: {
      styleOverrides: {
        root: {
          zIndex: '999999999999',
        },
      },
    },
    MuiCircularProgress: {
      styleOverrides: {
        circle: {
          color: '#afca33',
        },
      },

    },
    MuiButton: {
      styleOverrides: {
        root: {
          '&:focus': {
            outline: 'none',
          },
        },
        sizeMedium: {
          padding: '10px 20px',
          borderRadius: 0,
          textTransform: 'none',
          position: 'static',
          boxShadow: 'none',
        },
      },
    },
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          fontSize: '30px', // Set your desired medium font size here
        },
      },
    },
  },
};
